import script from "./DesktopOtherActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopOtherActions.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopOtherActions.vue?vue&type=style&index=0&id=2812c3fc&lang=scss"

const __exports__ = script;

export default __exports__